<template>
  <div class="border p-2 min-h-48 bg-gray-100">
    <div class="font-bold text-xs">Block: {{ block.name }} ({{ block.data?.component }})</div>
    <!-- <div class="debug text-xs">{{ block }}</div> -->
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})
</script>

<style lang="scss" scoped>
//
</style>